export enum ErrorStatuses {
  INVALID_TEMPLATE = "INVALID_TEMPLATE",
  INVALID_PREDICTION = "INVALID_PREDICTION",
  INVALID_MARKET = "INVALID_MARKET",
  INVALID_FIELD = "INVALID_FIELD",
  INVALID_TYPE = "INVALID_TYPE",
  EXCEEDED_LENGTH = "EXCEEDED_LENGTH",
  INVALID_TOKEN = "invalid_token",
  UNAUTHORIZED = "unauthorized",
  INVALID_FILTERS = "invalid_filters",
  INVALID_AVATAR = "invalid_avatar",
  INVALID_METHOD_CALL = "invalid_method_call",
  INVALID_LIMIT = "invalid_limit",
  INVALID_TEMPLATE_GROUP_ID = "invalid_template_group_id",
  INVALID_TEMPLATE_GROUP_FILTERS = "invalid_template_group_filters",
  INVALID_PAGE_NUMBER = "invalid_page_number",
  INVALID_DISCUSSION_IDS = "invalid_discussion_ids",
  ID_MAPPING_NOT_FOUND = "id_mapping_not_found",
  INVALID_COMPETITION_ID = "invalid_competition_id",
  INVALID_TEAM_ID = "invalid_team_id",
  INVALID_IDS = "invalid_ids",
  INVALID_INPUT_PROVIDER = "invalid_input_provider",
  INVALID_OUTPUT_PROVIDER = "invalid_output_provider",
  INVALID_MATCH_SUMMARY = "invalid_match_summary",
  INVALID_MATCH_SUMMARY_PREDICTIONS = "invalid_match_summary_predictions",
  INVALID_MATCH_SUMMARY_PREDICTIONS_KEYS = "invalid_match_summary_predictions_keys",
  ENTITY_IDS_NOT_FOUND = "entity_ids_not_found",
  MATCH_IDS_NOT_FOUND = "match_ids_not_found",
  INVALID_MATCH_IDS = "invalid_match_ids",
  ODD_CLIENT_CONFIGURATION_NOT_FOUND = "odd_client_configuration_not_found",
}
